import { getLocalStorage, saveLocalStorage } from "@elit-hair/elit-tools";

import { LOCAL_STORAGE_KEYS } from "@/constants/local-storage-keys";

type DarwinDrafts = Record<string, string>;

const readDrafts = (): DarwinDrafts => getLocalStorage<DarwinDrafts>(LOCAL_STORAGE_KEYS.AI_CHAT_DRAFTS.key, {});

export const readDarwinDraft = (draftKey: string): string => readDrafts()[draftKey] ?? "";

/** Saves unsent chat input; an empty value removes the draft. */
export const writeDarwinDraft = ({ draftKey, value }: { draftKey: string; value: string }): void => {
    const drafts = readDrafts();
    if ((drafts[draftKey] ?? "") === value) return;

    if (value) drafts[draftKey] = value;
    else delete drafts[draftKey];
    saveLocalStorage(LOCAL_STORAGE_KEYS.AI_CHAT_DRAFTS.key, drafts);
};
